import React, { useEffect, useState, useContext} from 'react';
import { useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import PersonIcon from '@material-ui/icons/Person';
import RoomIcon from '@material-ui/icons/Room';
import { Button } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Cookies from 'js-cookie';

import Stations from './Stations';
import StationDetails from './StationDetails';


import '../../scss/components/_user_management.scss';

import API_PATH from "../../constants/config.json";
import AddStation from './AddStation';
import AddNewStation from './AddNewStation';
import MapContext from '../../context/MapContext'

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
    );
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
  
function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const StationManagment = props => {

    const theme = useTheme();
    const [value, setValue] = useState(0);
    const [usTab, setUsTab] = React.useState("fo");
    const [teTab, setTeTab] = React.useState("fo");

    const [showStationDetails, setShowStationDetails] = useState(false);
    
   
    const [showDisableUser, setShowDisableUser] = useState(false);
    const [activeUsername, setActiveUsername] = useState(null);
    const [showAddStation, setShowAddStation] = useState(false);
    const [needToReload, setNeedToReload] = useState(true);

    const [showGroupTabs, setShowGroupTabs] = useState(false);
    const [selectedStationID, setSelectedStationID] = useState(null);
    const [selectedStationType, setSelectedStationType]=useState(null);
    const [showActions, setShowActions] = useState(false);
    const [actionsTop, setActionsTop] = useState(0);
    const [actionsLeft, setActionsLeft] = useState(0);

    const [scrolled, setScrolled] = useState(false);
    const {updAddNewStation}=useContext(MapContext)

    useEffect(() => {
        if(needToReload) {
            setNeedToReload(false);
        }
    }, [needToReload])

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setNeedToReload(true);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

  

    const handleDeleteUser = (opt) => {
        setShowDisableUser(opt);
    }

   
    const handleGroupTabs = (teamId) => {
        sessionStorage.setItem('teamId', teamId);
        setShowGroupTabs(true);
    }

    const handleShowActions = (e,station_id,station_type) => {
        console.log("station_id",station_id)
        sessionStorage.setItem('viewStationId', station_id);
        
        setSelectedStationID(station_id);
        setSelectedStationType(station_type);
        setActionsTop(e.pageY);
        setActionsLeft(e.pageX-107);
        setShowActions(true);
    }

    const handleClickAway = () => {
        setShowActions(false);
    }

    const handlestationAction = (opt) => {
        setShowActions(false);
        if(opt === 'details') 
             handleStationDetails(selectedStationID, selectedStationType);
        else if (opt === 'delete'){
            rejectFile();
        }
            
    }

    const handleStationDetails = (station_id, station_type) => {
        sessionStorage.setItem('viewStationId', station_id);
        setShowStationDetails(true);
    }
  
    const rejectFile = () => {
        try {
          axios({
            method: 'delete',
            url: API_URL + API_PATH.deleteStations + '/' + selectedStationID,
            headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
            },
          })
            .then(async function (response) {
              if (response.status && response.status == '200') {
                setNeedToReload(true)
                // getFileList(props.stationId);
                //getStationsAPI();
                //setSuccessMsg(true);
              }
               if (response.status && response.status == '204'){
                //getStationsAPI();
                //setErrorMsg(true);
              }
            })
            .catch(function (error) {
              console.log(error)
              //setSuccessMsg(false);
              //setErrorMsg(false);
            })
        } catch (error) {
          console.error(error);
          //setSuccessMsg(false);
          //setErrorMsg(false);
        }
        
      }

    const handleScroll = (tableRef) => {
        if (tableRef.current) {
          const { scrollTop } = tableRef.current.children[0].children[1].children[0].children[0].children[0].children[0].children[1];
          if (scrollTop > 0) {
            setScrolled(true);
          } else {
            setScrolled(false);
          }
        }
    };
    const updateList=(value)=>{
      setNeedToReload(value)
    }

    const closeStationManagement=()=>{
      props.setOpenStationManagement(false);
      //add new station to geojson layer
      //updAddNewStation(true);
    }

    return (
        <React.Fragment>
            <CssBaseline />
            <div className="management-main">
                <Container className="management-container-station" >
                    <AppBar position="static" color="default" className="tabs-header">
                        <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                        >
                            <Tab label="Stations" {...a11yProps(0)} id="" data-testid="" className={"stationTab"}  style={{width:'80px',height:'36px'}}/>
                            
                        </Tabs>
                        <div className="add-user-cnt">
                            <Button className="add-user-btn" onClick={() => setShowAddStation(true) } ><RoomIcon /> Add station</Button>
                            <img src={require('../../assets/icons/close.svg')} onClick={() => closeStationManagement()} />
                        </div>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={value}
                        onChangeIndex={handleChangeIndex}
                    >
                        <TabPanel value={value} index={0} dir={theme.direction} >
                        <div className="stations-table-cnt" >
                        <Stations 
                                handleStationDetails={handleStationDetails} 
                                setShowStationDetails={setShowStationDetails}  
                                setActiveUsername={setActiveUsername}
                                handlestationAction={handlestationAction}
                                needToReload={needToReload}
                                handleShowActions={handleShowActions}
                                handleScroll={handleScroll}
                                scrolled={scrolled}
                            />
                        </div>
                        </TabPanel>
                      
                    </SwipeableViews>
                </Container>
            </div>
            {
                showActions &&
                <ClickAwayListener onClickAway={handleClickAway}>
                <div className="actions-panel" style={{top: actionsTop+'px', left: actionsLeft+'px'}}>
                       
                        <div onClick={() => handlestationAction('delete')}>
                            <img src={require('../../assets/icons/Trash.png')} />
                            <label>Delete</label>
                        </div>
                    </div>
                </ClickAwayListener>
            }
           {
                showStationDetails &&
                <StationDetails 
                    setShowStationDetails={setShowStationDetails} 
                   
                   
                    setNeedToReload={setNeedToReload}
                    needToReload={needToReload}
                    updateList={updateList}
                />
            }
               {
                showAddStation &&
                <AddNewStation 
                    setShowStationDetails={setShowAddStation}                    
                    setNeedToReload={setNeedToReload}
                    needToReload={needToReload}
                />
            }
        </React.Fragment>
    )
}

export default StationManagment;